import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAppStore } from '@/stores'

/**
 * 应用布局
 * @returns
 */
export const ContentLayout = () => {
  const { setLayoutOptions } = useAppStore()

  useEffect(() => {
    setLayoutOptions({ showNav: true, showHeader: true })
  }, [])

  return (
    <>
      <Outlet />
    </>
  )
}
